import { createStyles } from '@mantine/core';
import { IconPhotoOff } from '@tabler/icons-react';

const useStyles = createStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

function ImagePlaceholder({
  width,
  height,
  color,
}: {
  width: number;
  height: number;
  color?: string;
}) {
  const { classes } = useStyles();

  const iconSize = Math.min(16, Math.min(width, height) - 2);

  return (
    <div className={classes.container} style={{ width, height }}>
      <IconPhotoOff size={iconSize} color={color} />
    </div>
  );
}

export default ImagePlaceholder;
